import React, { useState, useEffect } from 'react'
import { Button, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useTheme } from '@mui/material'
import { Item } from '../../../common/snippets'
import { Box, fontSize } from '@mui/system'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import {
  detailColumnsStyles,
  detailFormateData,
  jsPdfHeaderFooter,
  pdfHeaderColumn,
  //   PDFHeaderColumns,
  DetailsDrawCell,
  PDFHeaderColumnsForEx,
  excelHeader,
  detailColumnsStylesTwo,
  PDFHeaderColumnsWithoughtPayType,
  PDFHeaderColumnsWithPayType,
  PDFHeaderColumnsWithPayTypeFormattedLRNO,
  PDFHeaderColumnsWithPayTypeForBoth,
  PDFHeaderColumnsWithoughtPayTypeFormattedLRNO,
  PDFHeaderColumnsWithoughtPayTypeForBoth,
  DetailsDrawCell2,
} from './constants'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { callAddFontRobotoBold } from '../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../common/font/Roboto-Medium-normal'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { useSelector } from 'react-redux'
import { colors } from '../../../common/helper'
import moment from 'moment'
import * as id from '../reportId'
import { focusElemnt, navigation3 } from '../../../common/helper'

const BranchStockReportTable = (props) => {
  const { headerData, tablesData, reportGroupByOptions, reportView, reportOptions, sourceBranch, destinationCity, destinationBranch, UseFormattedLRinReports } =
    props
  const theme = useTheme()
  const { tableHeaderColor } = theme
  const filterData = tablesData.filter((item) => item.TYPE === reportOptions?.optionType)
  const freightTotal = filterData.reduce((a, b) => Number(a) + Number(b.TotalFreight), 0)
  const cartageTotal = filterData.reduce((a, b) => Number(a) + Number(b.Cartage), 0)
  const hamaliTotal = filterData.reduce((a, b) => Number(a) + Number(b.Hamali), 0)
  const netAmountTotal = filterData.reduce((a, b) => Number(a) + Number(b.TotalNet), 0)
  const totalRow = {
    isTotal: true,
    PaymentType: 'Total:',
    Sr: '',
    LRNO: '',
    BookingDate: '',
    DestBranch: '',
    Sender: '',
    RecName: '',
    Qty: ' ',
    ItemDetails: '',
    TotalFreight: freightTotal,
    Cartage: cartageTotal,
    Hamali: hamaliTotal,
    TotalNet: netAmountTotal,
  }
  const tableData = [...filterData, totalRow]
  const groupBy = (array, key) => {
    return array.reduce((result, currentValue) => {
      ; (result[currentValue[key]] = result[currentValue[key]] || []).push(currentValue)
      return result
    }, {})
  }

  // Group by 'type'
  const groupedData = groupBy(filterData, 'PaymentType')

  const groupData = []

  Object.entries(groupedData).forEach(([PaymentType, items]) => {
    // Calculate totals for each group
    const freightTotal = items.reduce((a, b) => Number(a) + Number(b.TotalFreight), 0)
    const cartageTotal = items.reduce((a, b) => Number(a) + Number(b.Cartage), 0)
    const hamaliTotal = items.reduce((a, b) => Number(a) + Number(b.Hamali), 0)
    const netAmountTotal = items.reduce((a, b) => Number(a) + Number(b.TotalNet), 0)

    // Push group title (optional)
    // groupData.push({ isGroupHeader: true, type });
    groupData.push({
      isSubHeading: true,
      Sr: `${PaymentType} : ${reportOptions?.Option}`,
      colSpan: 11,
      align: 'left',
    })

    // Push group items
    groupData.push(...items)

    // Push total row for group
    groupData.push({
      isTotal: true,
      PaymentType,
      Sr: 'Total:',
      LRNO: '',
      BookingDate: '',
      DestBranch: '',
      Sender: '',
      RecName: '',
      Qty: ' ',
      ItemDetails: '',
      TotalFreight: freightTotal,
      Cartage: cartageTotal,
      Hamali: hamaliTotal,
      TotalNet: netAmountTotal,
    })
  })
  let serialNumber = 1 // Initialize serial number counter

  const finalTableData = groupData.map((row) => {
    if (!row.isSubHeading && !row.isTotal) {
      return { ...row, Sr: serialNumber++ } // Assign Sr and increment counter
    }
    return row // Keep other rows unchanged
  })

  const { loginData } = useSelector((state) => state?.common)

  const [showTableData, setShowTableData] = useState([])
  const [searchResult, setSearchResult] = useState(true)
  const [largePDF, setLargePDF] = useState(false)
  const [state, setState] = useState({
    generatePDF: false,
    load: false,
  })
  const { generatePDF, load } = { ...state }
  const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm')
  const PDFHeaderColumns = reportGroupByOptions === 'With Payment Type' ? UseFormattedLRinReports === 0 || UseFormattedLRinReports === 1 ? PDFHeaderColumnsWithPayType : UseFormattedLRinReports === 2 ? PDFHeaderColumnsWithPayTypeFormattedLRNO : PDFHeaderColumnsWithPayTypeForBoth :
    UseFormattedLRinReports === 0 || UseFormattedLRinReports === 1 ? PDFHeaderColumnsWithoughtPayType : UseFormattedLRinReports === 2 ? PDFHeaderColumnsWithoughtPayTypeFormattedLRNO : PDFHeaderColumnsWithoughtPayTypeForBoth
  useEffect(() => {
    if (reportGroupByOptions !== 'With Payment Type') {
      setShowTableData(tableData)
    } else {
      setShowTableData(finalTableData)
    }
  }, [])

  const printClick = (isSave) => {
    setState({ ...state, load: true, generatePDF: true })
    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
    const HeaderColumns = pdfHeaderColumn.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const pdfColumns = PDFHeaderColumns.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const doc = new jsPDF({ orientation: 'p', format: [1240, 1754], unit: 'px', compress: true })
    var totalPagesExp = '{total_pages_count_string}'
    doc.setProperties({
      title: `Branch Stock Reports.pdf`,
      subject: 'Branch Stock Report',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })
    autoTable(doc, {
      margin: { top: 60, left: 30, right: 30, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: HeaderColumns,
      body: [headerData],
      columnStyles: {
        0: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        1: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        2: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        3: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        4: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        5: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        6: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
      },
      theme: 'grid',
      startY: 160,
      headStyles: {
        fillColor: [191, 225, 255],
        textColor: [0, 0, 0],
        minCellHeight: 36,
        valign: 'middle',
        cellPadding: 12,
        fontSize: 18,
        font: 'Roboto',
        fontStyle: 'normal',
        lineWidth: 0.6,
      },
      didDrawPage: function (data) {
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(18).setFont('Roboto', 'bold')
        doc.text(`Booking Date : ${headerData?.fromDate}  To  ${headerData.toDate}`, data.settings.margin.left, 150)
        doc.text(`Report View: ${headerData.reportView}`, doc.internal.pageSize.width - data.settings.margin.left, 150, 'right')
      },
    })

    autoTable(doc, {
      margin: { top: 120, left: 30, right: 30, bottom: 40 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      headStyles: {
        fillColor: [191, 225, 255],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        valign: 'top',
        fontStyle: 'normal',
        font: 'Roboto',
        textColor: [0, 0, 0],
      },
      tableLineWidth: 0.6,
      columns: pdfColumns,
      body: reportGroupByOptions !== 'With Payment Type' ? tableData : finalTableData,
      styles: {
        lineWidth: [0, 0.2, 0, 0.2],
      },
      theme: 'grid',
      columnStyles: reportGroupByOptions !== 'With Payment Type' ? detailColumnsStyles : detailColumnsStylesTwo,
      didParseCell: (data) => {
        reportGroupByOptions === 'With Payment Type' ? DetailsDrawCell(data, UseFormattedLRinReports) : DetailsDrawCell2(data, UseFormattedLRinReports)
      },
      didDrawPage: function (data) {
        doc.setTextColor(40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(26).setFont('Roboto', 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text('Cargo System |  Branch Stock Report', 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(22).setFont('Roboto', 'bold')
        doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
        jsPdfHeaderFooter(data, loginData, totalPagesExp)
      },
    })
    doc.setFont('Roboto')

    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      doc.save(`Branch Stock Report ${currentDateTime}.pdf`)
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('gbDetailsOutput').data = pdfUrl
        // document.getElementById('gbDetailsOutput').data = doc.output('datauristring', ' Branch Stock Reports.pdf')
        focusElemnt('backBtn')
      }, 2000)
    } else {
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('gbDetailsOutput').data = pdfUrl
        // document.getElementById('gbDetailsOutput').data = doc.output('datauristring', ' Branch Stock Reports.pdf')
        focusElemnt('backBtn')
      }, 2000)
    }
  }
  const InsideRowContent = ({ item, index, fs = '12px' }) => {
    return (
      <TableRow className="receivedTr" key={index}>
        {item?.isSubHeading ? (
          <TableCell // Ensure each element has a unique key
            className="userwiseTD"
            colSpan={UseFormattedLRinReports === 3 ? 13 : 12}
            style={{ padding: '8px 9px', textAlign: 'left', verticalAlign: 'top', backgroundColor: tableHeaderColor?.isSubHeadingColor }}
          >
            {item.Sr}
          </TableCell>
        ) : item?.isTotal ? (
          <>
            <TableCell
              className="userWiseReportSubTotal"
              colSpan={UseFormattedLRinReports === 3 ? 8 : 7}
              style={{
                padding: '8px 9px',
                textAlign: 'right',
                backgroundColor: tableHeaderColor?.isTotalColor,
                height: '36px',
                fontSize: { fs },
              }}
            >
              {''}
            </TableCell>
            <TableCell
              className="userWiseReportSubTotal"
              colSpan={1}
              style={{
                padding: '8px 9px',
                textAlign: 'left',
                backgroundColor: tableHeaderColor?.isTotalColor,
                height: '36px',
                fontSize: { fs },
              }}
            >
              {'Total:'}
            </TableCell>
            <TableCell
              className="userWiseReportSubTotal"
              colSpan={1}
              style={{
                padding: '8px 9px',
                textAlign: 'right',
                backgroundColor: tableHeaderColor?.isTotalColor,
                height: '36px',
                fontSize: { fs },
              }}
            >
              {item.TotalFreight}
            </TableCell>
            <TableCell
              className="userWiseReportSubTotal"
              colSpan={1}
              style={{
                padding: '8px 9px',
                textAlign: 'right',
                backgroundColor: tableHeaderColor?.isTotalColor,
                height: '36px',
                fontSize: { fs },
              }}
            >
              {item.Cartage}
            </TableCell>
            <TableCell
              className="userWiseReportSubTotal"
              colSpan={1}
              style={{
                padding: '8px 9px',
                textAlign: 'right',
                backgroundColor: tableHeaderColor?.isTotalColor,
                height: '36px',
                fontSize: { fs },
              }}
            >
              {item.Hamali}
            </TableCell>
            <TableCell
              className="userWiseReportSubTotal"
              colSpan={1}
              style={{
                padding: '8px 9px',
                textAlign: 'right',
                backgroundColor: tableHeaderColor?.isTotalColor,
                height: '36px',
                fontSize: { fs },
              }}
            >
              <span style={{ color: '#0086FF' }}>{item.TotalNet}</span>
            </TableCell>
          </>
        ) : (
          <>
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', textAlign: 'left', verticalAlign: 'top', maxWidth: '10px', fontSize: { fs } }}
            >
              {item.Sr}
            </TableCell>

            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', textAlign: 'left', verticalAlign: 'top', borderRight: 'none', maxWidth: '90px', fontSize: { fs } }}
            >
              {UseFormattedLRinReports !== 2 ? item.LRNO : item.FormattedLRNO}
            </TableCell>
            {
              UseFormattedLRinReports === 3 &&
              <TableCell
                className="userwiseTD"
                colSpan={1}
                style={{ padding: '8px 9px', textAlign: 'left', verticalAlign: 'top', borderRight: 'none', maxWidth: '90px', fontSize: { fs } }}
              >
                {item.FormattedLRNO}
              </TableCell>
            }
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', textAlign: 'left', verticalAlign: 'top', maxWidth: '10px', fontSize: { fs } }}
            >
              {item.BookingDate}
            </TableCell>
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', textAlign: 'left', verticalAlign: 'top', maxWidth: '10px', fontSize: { fs } }}
            >
              {item.DestinationBranch}
            </TableCell>
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', textAlign: 'left', verticalAlign: 'top', maxWidth: '10px', fontSize: { fs } }}
            >
              {item.Sender}
            </TableCell>
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', textAlign: 'left', verticalAlign: 'top', maxWidth: '10px', fontSize: { fs } }}
            >
              {item.RecName}
            </TableCell>
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', textAlign: 'right', verticalAlign: 'top', maxWidth: '10px', fontSize: { fs } }}
            >
              {item.TotalQuantity}
            </TableCell>
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', textAlign: 'left', verticalAlign: 'top', maxWidth: '10px', fontSize: { fs } }}
            >
              {item.ItemDetails}
            </TableCell>
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', textAlign: 'right', verticalAlign: 'top', maxWidth: '10px', fontSize: { fs } }}
            >
              {item.TotalFreight}
            </TableCell>
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', textAlign: 'right', verticalAlign: 'top', maxWidth: '10px', fontSize: { fs } }}
            >
              {item.Cartage}
            </TableCell>
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', textAlign: 'right', verticalAlign: 'top', maxWidth: '10px', fontSize: { fs } }}
            >
              {item.Hamali}
            </TableCell>
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', textAlign: 'right', verticalAlign: 'top', maxWidth: '10px', fontSize: { fs } }}
            >
              <span style={{ color: '#0086FF' }}>{item.TotalNet}</span>
            </TableCell>
          </>
        )}
      </TableRow>
    )
  }
  const InsideRowContentTwo = ({ item, index, fs = '12px' }) => {
    return (
      <TableRow className="receivedTr" key={index}>
        {item?.isTotal ? (
          <>
            <TableCell
              className="userWiseReportSubTotal"
              colSpan={UseFormattedLRinReports === 3?9:8}
              style={{
                padding: '8px 9px',
                textAlign: 'right',
                backgroundColor: tableHeaderColor?.isTotalColor,
                height: '36px',
                fontSize: { fs },
              }}
            >
              {''}
            </TableCell>
            <TableCell
              className="userWiseReportSubTotal"
              colSpan={1}
              style={{
                padding: '8px 9px',
                textAlign: 'left',
                backgroundColor: tableHeaderColor?.isTotalColor,
                height: '36px',
                fontSize: { fs },
                fontWeight: '700'
              }}
            >
              {'Total:'}
            </TableCell>
            <TableCell
              className="userWiseReportSubTotal"
              colSpan={1}
              style={{
                padding: '8px 9px',
                textAlign: 'right',
                backgroundColor: tableHeaderColor?.isTotalColor,
                height: '36px',
                fontSize: { fs },
                fontWeight: '700'
              }}
            >
              {item.TotalFreight}
            </TableCell>
            <TableCell
              className="userWiseReportSubTotal"
              colSpan={1}
              style={{
                padding: '8px 9px',
                textAlign: 'right',
                backgroundColor: tableHeaderColor?.isTotalColor,
                height: '36px',
                fontSize: { fs },
                fontWeight: '700'
              }}
            >
              {item.Cartage}
            </TableCell>
            <TableCell
              className="userWiseReportSubTotal"
              colSpan={1}
              style={{
                padding: '8px 9px',
                textAlign: 'right',
                backgroundColor: tableHeaderColor?.isTotalColor,
                height: '36px',
                fontSize: { fs },
                fontWeight: '700'
              }}
            >
              {item.Hamali}
            </TableCell>
            <TableCell
              className="userWiseReportSubTotal"
              colSpan={1}
              style={{
                padding: '8px 9px',
                textAlign: 'right',
                backgroundColor: tableHeaderColor?.isTotalColor,
                height: '36px',
                fontSize: { fs },
                fontWeight: '700'
              }}
            >
              <span style={{ color: '#0086FF' }}>{item.TotalNet}</span>
            </TableCell>
          </>
        ) : (
          <>
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', textAlign: 'left', verticalAlign: 'top', maxWidth: '10px', fontSize: { fs } }}
            >
              {item.Sr}
            </TableCell>
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px',textAlign: 'left', verticalAlign: 'top', borderRight: 'none', maxWidth: '90px', fontSize: { fs } }}
            >
              {UseFormattedLRinReports !== 2 ? item.LRNO : item.FormattedLRNO}
            </TableCell>
            {
              UseFormattedLRinReports === 3 &&
              <TableCell
                className="userwiseTD"
                colSpan={1}
                style={{ padding: '8px 9px',textAlign: 'left', verticalAlign: 'top', borderRight: 'none', maxWidth: '90px', fontSize: { fs } }}
              >
                {item.FormattedLRNO}
              </TableCell>
            }
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', textAlign: 'left', verticalAlign: 'top', maxWidth: '10px', fontSize: { fs } }}
            >
              {item.BookingDate}
            </TableCell>
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', textAlign: 'left', verticalAlign: 'top', maxWidth: '10px', fontSize: { fs } }}
            >
              {item.DestinationBranch}
            </TableCell>
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', textAlign: 'left', verticalAlign: 'top', maxWidth: '10px', fontSize: { fs } }}
            >
              {item.Sender}
            </TableCell>
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', textAlign: 'left', verticalAlign: 'top', maxWidth: '10px', fontSize: { fs } }}
            >
              {item.RecName}
            </TableCell>
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', textAlign: 'right', verticalAlign: 'top', maxWidth: '10px', fontSize: { fs } }}
            >
              {item.TotalQuantity}
            </TableCell>
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', textAlign: 'left', verticalAlign: 'top', maxWidth: '10px', fontSize: { fs } }}
            >
              {item.ItemDetails}
            </TableCell>
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', textAlign: 'left', verticalAlign: 'top', maxWidth: '10px', fontSize: { fs } }}
            >
              {item.PaymentType}
            </TableCell>
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', textAlign: 'right', verticalAlign: 'top', maxWidth: '10px', fontSize: { fs } }}
            >
              {item.TotalFreight}
            </TableCell>
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', textAlign: 'right', verticalAlign: 'top', maxWidth: '10px', fontSize: { fs } }}
            >
              {item.Cartage}
            </TableCell>
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', textAlign: 'right', verticalAlign: 'top', maxWidth: '10px', fontSize: { fs } }}
            >
              {item.Hamali}
            </TableCell>
            <TableCell
              className="userwiseTD"
              colSpan={1}
              style={{ padding: '8px 9px', textAlign: 'right', verticalAlign: 'top', maxWidth: '10px', fontSize: { fs } }}
            >
              <span style={{ color: '#0086FF' }}>{item.TotalNet}</span>
            </TableCell>
          </>
        )}
      </TableRow>
    )
  }
  return (
    <>
      <Stack style={{ margin: '0px 10px', marginRight: '0px' }}>
        <Item className="userReport">
          <Item className="userReport-heading">Report For: Branch Stock Report</Item>
          <Item className="userReport-buttons">
            {searchResult ? (
              <>
                <Box onKeyDown={(e) => navigation3(e, 'ExportToPdf', id.reportmainButton, () => { })}>
                  <ReactHtmlTableToExcel
                    id="ExportToExl"
                    className="userWisereporttemExcelBtn"
                    table="table-gbDetailsTableReport-xls"
                    filename={`Branch Stock Report ${currentDateTime}`}
                    sheet="tablexls"
                    buttonText="Export to Excel"
                  />
                </Box>
                <Box>
                  <Button
                    variant="outlined"
                    className="userWisereporttembtn"
                    id="ExportToPdf"
                    onClick={() => {
                      setSearchResult(false)
                      printClick(true)
                    }}
                    onKeyDown={(e) =>
                      navigation3(e, 'PrintBtn', 'ExportToExl', () => {
                        setSearchResult(false)
                        printClick(true)
                      })
                    }
                  >
                    Export to Pdf
                  </Button>
                </Box>
                <Box>
                  <Button
                    variant="outlined"
                    id="PrintBtn"
                    className="userWisereporttembtn"
                    onClick={() => {
                      setSearchResult(false)
                      printClick(false)
                    }}
                    onKeyDown={(e) =>
                      navigation3(e, id.fromDate, 'ExportToPdf', () => {
                        setSearchResult(true)
                        printClick(false)
                      })
                    }
                  >
                    Print
                  </Button>
                </Box>
              </>
            ) : (
              <>
                <Box>
                  <Button
                    variant="outlined"
                    id="backBtn"
                    className="userWisereporttembtn"
                    onClick={() => {
                      setSearchResult(true)
                    }}
                    onKeyDown={(e) =>
                      navigation3(e, id.fromDate, id.reportmainButton, () => {
                        setSearchResult(true)
                        setLargePDF(false)
                        focusElemnt(id.reportmainButton)
                      })
                    }
                  >
                    Back
                  </Button>
                </Box>
              </>
            )}
          </Item>
        </Item>
      </Stack>
      {searchResult ? (
        <Stack sx={{ marginLeft: 2, marginRight: 1, height: 470 }} className="scroll">
          <TableContainer
            className="lr-popup-table lrModel "
            component={Paper}
            style={{ borderRadius: '6px', border: '1px solid #aeaeae' }}
          >
            {reportGroupByOptions === 'With Payment Type' ? (
              <>
                <Table size="small" aria-label="a dense table">
                  <TableHead style={{ position: `sticky`, top: `0`, background: `white`, borderRadius: '10px 10px 10px 10px' }}>
                    <TableRow>
                      <TableCell className="reportTD" style={{ fontSize: '14px', fontWeight: '600', textAlign: 'left', padding: '0px 10px' }} colSpan={PDFHeaderColumns.length}>
                        {reportOptions?.Option === 'Pending Dispatch' ? <h3>{`Booked - Pending Dispatch`}</h3> : <h3>{`Received - ${reportOptions?.Option}`}</h3>}
                      </TableCell>
                    </TableRow>
                    <TableRow className="sammary-heading" style={{ borderRadius: '10px 10px 10px 10px' }}>
                      {PDFHeaderColumns?.map((item, i) => (
                        <TableCell
                          className="userWiseReportHeading"
                          key={i}
                          style={{
                            textAlign: item.align,
                            verticalAlign: 'top',
                            color: tableHeaderColor.textColor,
                            backgroundColor: tableHeaderColor.isHeadingColor,
                            whiteSpace: 'pre-line',
                          }}
                        >
                          {item?.headerName}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  {finalTableData?.length < 1 ? (
                    <>
                      <TableBody>
                        <TableRow>
                          <TableCell colSpan={11}>
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                marginTop: '20px',
                                marginBottom: '20px',
                                color: 'red',
                                fontSize: '14px',
                              }}
                            >
                              <span>No results found. Please refine your search parameters and search again.</span>
                            </div>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </>
                  ) : finalTableData.length > 0 ? (
                    <TableBody className="filter-data-row-BorderNone" sx={{ border: 'none !important' }}>
                      {finalTableData?.map((item, index) => (
                        <InsideRowContent item={item} index={index} key={index} fs={'12px'} />
                      ))}
                    </TableBody>
                  ) : (
                    ''
                  )}
                </Table>
                <Table size="small" aria-label="a dense table" id="table-gbDetailsTableReport-xls" style={{ display: 'none' }}>
                  <TableHead style={{ position: `sticky`, top: `0`, background: `white`, borderRadius: '10px 10px 10px 10px' }}>
                    <TableRow style={{ fontSize: '18px', fontWeight: '500', textAlign: 'left' }}>
                      <TableCell className="reportTD" colSpan={5}>
                        Report For:Branch Stock Report
                      </TableCell>
                      <TableCell className="reportTD" colSpan={6}>
                        Company Name : _Maven Tech Services Pvt. Ltd.
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={11}></TableCell>
                    </TableRow>
                    <TableRow style={{ color: 'white' }}>
                      {excelHeader?.map((item, i) => (
                        <TableCell
                          className="ReportItemHead"
                          style={{ backgroundColor: '#e5f3ff', color: '#444444', fontSize: '12px', fontWeight: '600', textAlign: 'left' }}
                          colSpan={1}
                          key={i}
                        >
                          {item.headerName}
                        </TableCell>
                      ))}
                    </TableRow>
                    <TableRow>
                      <TableCell className="reportTD" style={{ fontSize: '12px', fontWeight: '600', textAlign: 'left' }} colSpan={1}>
                        {moment(headerData.fromDate).format('DD/MM/YYYY')}
                      </TableCell>
                      <TableCell className="reportTD" style={{ fontSize: '12px', fontWeight: '600', textAlign: 'left' }} colSpan={1}>
                        {moment(headerData.toDate).format('DD/MM/YYYY')}
                      </TableCell>
                      <TableCell className="reportTD" style={{ fontSize: '12px', fontWeight: '600', textAlign: 'left' }} colSpan={1}>
                        {sourceBranch?.SourceBranchName}
                      </TableCell>
                      <TableCell className="reportTD" style={{ fontSize: '12px', fontWeight: '600', textAlign: 'left' }} colSpan={1}>
                        {destinationCity?.DestCityName}
                      </TableCell>
                      <TableCell className="reportTD" style={{ fontSize: '12px', fontWeight: '600', textAlign: 'left' }} colSpan={1}>
                        {destinationBranch?.DestBranchName}
                      </TableCell>
                      <TableCell className="reportTD" style={{ fontSize: '12px', fontWeight: '600', textAlign: 'left' }} colSpan={1}>
                        {headerData?.paymentType}
                      </TableCell>
                      <TableCell className="reportTD" style={{ fontSize: '12px', fontWeight: '600', textAlign: 'left' }} colSpan={1}>
                        {headerData?.reportView}
                      </TableCell>
                      <TableCell className="reportTD" style={{ fontSize: '12px', fontWeight: '600', textAlign: 'left' }} colSpan={1}>
                        {headerData?.reportOptions?.Option}
                      </TableCell>
                      <TableCell className="reportTD" style={{ fontSize: '12px', fontWeight: '600', textAlign: 'left' }} colSpan={1}>
                        {headerData?.reportGroupBy}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="reportTD" style={{ fontSize: '14px', fontWeight: '600', textAlign: 'left' }} colSpan={11}>
                        <h4>{`Booked - ${reportOptions?.Option}`}</h4>
                      </TableCell>
                    </TableRow>
                    <TableRow className="sammary-heading" style={{ borderRadius: '10px 10px 10px 10px' }}>
                      {PDFHeaderColumns?.map((item, i) => (
                        <TableCell
                          className="userWiseReportHeading"
                          key={i}
                          style={{
                            textAlign: item.align,
                            verticalAlign: 'top',
                            color: tableHeaderColor.textColor,
                            backgroundColor: tableHeaderColor.isHeadingColor,
                            whiteSpace: 'pre-line',
                          }}
                        >
                          {item?.headerName}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  {finalTableData?.length < 1 ? (
                    <>
                      <TableBody>
                        <TableRow>
                          <TableCell colSpan={11}>
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                marginTop: '20px',
                                marginBottom: '20px',
                                color: 'red',
                                fontSize: '14px',
                              }}
                            >
                              <span>No results found. Please refine your search parameters and search again.</span>
                            </div>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </>
                  ) : finalTableData.length > 0 ? (
                    <TableBody className="filter-data-row-BorderNone" sx={{ border: 'none !important' }}>
                      {finalTableData?.map((item, index) => (
                        <InsideRowContent item={item} index={index} key={index} fs={'20px'} />
                      ))}
                    </TableBody>
                  ) : (
                    ''
                  )}
                </Table>
              </>
            ) : (
              <>
                <Table size="small" aria-label="a dense table">
                  <TableHead style={{ position: `sticky`, top: `0`, background: `white`, borderRadius: '10px 10px 10px 10px' }}>
                    <TableRow>
                      <TableCell className="reportTD" style={{ fontSize: '14px', fontWeight: '600', textAlign: 'left' }} colSpan={PDFHeaderColumns.length}>
                        <h3>{`Booked - ${reportOptions?.Option}`}</h3>
                      </TableCell>
                    </TableRow>
                    <TableRow className="sammary-heading" style={{ borderRadius: '10px 10px 10px 10px' }}>
                      {PDFHeaderColumns?.map((item, i) => (
                        <TableCell
                          className="userWiseReportHeading"
                          key={i}
                          style={{
                            textAlign: item.align,
                            verticalAlign: 'top',
                            color: tableHeaderColor.textColor,
                            backgroundColor: tableHeaderColor.isHeadingColor,
                            whiteSpace: 'pre-line',
                          }}
                        >
                          {item?.headerName}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  {tableData?.length < 1 ? (
                    <>
                      <TableBody>
                        <TableRow>
                          <TableCell colSpan={11}>
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                marginTop: '20px',
                                marginBottom: '20px',
                                color: 'red',
                                fontSize: '14px',
                              }}
                            >
                              <span>No results found. Please refine your search parameters and search again.</span>
                            </div>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </>
                  ) : tableData.length > 0 ? (
                    <TableBody className="filter-data-row-BorderNone" sx={{ border: 'none !important' }}>
                      {tableData?.map((item, index) => (
                        <InsideRowContentTwo item={item} index={index} key={index} fs={'12px'} />
                      ))}
                    </TableBody>
                  ) : (
                    ''
                  )}
                </Table>
                <Table size="small" aria-label="a dense table" id="table-gbDetailsTableReport-xls" style={{ display: 'none' }}>
                  <TableHead style={{ position: `sticky`, top: `0`, background: `white`, borderRadius: '10px 10px 10px 10px' }}>
                    <TableRow style={{ color: 'white' }}>
                      {pdfHeaderColumn?.map((item, i) => (
                        <TableCell
                          className="ReportItemHead"
                          style={{ backgroundColor: '#e5f3ff', color: '#444444', fontSize: '14px', fontWeight: '600', textAlign: 'left' }}
                          colSpan={1}
                          key={i}
                        >
                          {item.headerName}
                        </TableCell>
                      ))}
                    </TableRow>
                    <TableRow>
                      <TableCell className="reportTD" style={{ fontSize: '14px', fontWeight: '600', textAlign: 'left' }} colSpan={1}>
                        {moment(headerData.fromDate).format('DD/MM/YYYY')}
                      </TableCell>
                      <TableCell className="reportTD" style={{ fontSize: '14px', fontWeight: '600', textAlign: 'left' }} colSpan={1}>
                        {moment(headerData.toDate).format('DD/MM/YYYY')}
                      </TableCell>
                      <TableCell className="reportTD" style={{ fontSize: '14px', fontWeight: '600', textAlign: 'left' }} colSpan={1}>
                        {headerData.sourceBranch}
                      </TableCell>
                      <TableCell className="reportTD" style={{ fontSize: '14px', fontWeight: '600', textAlign: 'left' }} colSpan={1}>
                        {headerData?.destinationCity}
                      </TableCell>
                      <TableCell className="reportTD" style={{ fontSize: '14px', fontWeight: '600', textAlign: 'left' }} colSpan={1}>
                        {headerData?.destinationBranch}
                      </TableCell>
                      <TableCell className="reportTD" style={{ fontSize: '14px', fontWeight: '600', textAlign: 'left' }} colSpan={1}>
                        {headerData?.PaymentType}
                      </TableCell>
                      <TableCell className="reportTD" style={{ fontSize: '14px', fontWeight: '600', textAlign: 'left' }} colSpan={1}>
                        {headerData?.reportView}
                      </TableCell>
                      <TableCell className="reportTD" style={{ fontSize: '14px', fontWeight: '600', textAlign: 'left' }} colSpan={1}>
                        {headerData?.reportOptions}
                      </TableCell>
                      <TableCell className="reportTD" style={{ fontSize: '14px', fontWeight: '600', textAlign: 'left' }} colSpan={1}>
                        {headerData?.reportGroupBy}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="reportTD" style={{ fontSize: '14px', fontWeight: '600', textAlign: 'left' }} colSpan={11}>
                        <h4>{`Booked - ${reportOptions?.Option}`}</h4>
                      </TableCell>
                    </TableRow>
                    <TableRow className="sammary-heading" style={{ borderRadius: '10px 10px 10px 10px' }}>
                      {PDFHeaderColumns?.map((item, i) => (
                        <TableCell
                          className="userWiseReportHeading"
                          key={i}
                          style={{
                            textAlign: item.align,
                            verticalAlign: 'top',
                            color: tableHeaderColor.textColor,
                            backgroundColor: tableHeaderColor.isHeadingColor,
                            whiteSpace: 'pre-line',
                          }}
                        >
                          {item?.headerName}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  {tableData?.length < 1 ? (
                    <>
                      <TableBody>
                        <TableRow>
                          <TableCell colSpan={11}>
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                marginTop: '20px',
                                marginBottom: '20px',
                                color: 'red',
                                fontSize: '14px',
                              }}
                            >
                              <span>No results found. Please refine your search parameters and search again.</span>
                            </div>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </>
                  ) : tableData.length > 0 ? (
                    <TableBody className="filter-data-row-BorderNone" sx={{ border: 'none !important' }}>
                      {tableData?.map((item, index) => (
                        <InsideRowContentTwo item={item} index={index} key={index} fs={'14px'} />
                      ))}
                    </TableBody>
                  ) : (
                    ''
                  )}
                </Table>
              </>
            )}
          </TableContainer>
        </Stack>
      ) : (
        <>
          <Box sx={{ ...sx.reportFlex, justifyContent: 'center' }}>
            {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
            {load ? (
              <object
                id="gbDetailsOutput"
                type="application/pdf"
                width={'100%'}
                height="440"
                title="MTLPL -Cargo System -Branch Stock Report"
                aria-label="MTLPL -Cargo System -Branch Stock Report"
              ></object>
            ) : (
              ''
            )}
            {/* </>
                        } */}
          </Box>
        </>
      )}
    </>
  )
}

export default BranchStockReportTable
